"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBootcampCheckoutInfoContext = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const language_codes_types_1 = require("./language_codes_types");
const SanityBootcampParticipantSchema = zod_1.z.object({
    _type: zod_1.z.literal("participant"),
    activeLanguages: zod_1.z.array(language_codes_types_1.LanguagePairCodeSchema),
    email: zod_1.z.string().optional(),
    enrolledBootcamps: zod_1.z.array(zod_1.z.string()),
    name: zod_1.z.string().optional(),
    user_id: zod_1.z.string(),
});
const BootcampCheckoutInfoContextSchema = zod_1.z.object({
    bootcampsToEnroll: zod_1.z.array(zod_1.z.string()),
    isIntense: zod_1.z.boolean(),
    isPrivate: zod_1.z.boolean(),
    isSixBootcamps: zod_1.z.boolean(),
    reason: zod_1.z.string(),
});
exports.isBootcampCheckoutInfoContext = type_validation_helpers_1.getVerboseTypeValidationFunction(BootcampCheckoutInfoContextSchema);
//# sourceMappingURL=bootcamp_types.js.map